import { createElement } from 'react';

import ApprovalIcon from '@mui/icons-material/Approval';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import BackspaceIcon from '@mui/icons-material/Backspace';
import BioTechIcon from '@mui/icons-material/Biotech';
import BrowserNotSupportedIcon from '@mui/icons-material/BrowserNotSupported';
import BusinessIcon from '@mui/icons-material/Business';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CancelScheduleIcon from '@mui/icons-material/CancelScheduleSend';
import ChecklistIcon from '@mui/icons-material/Checklist';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import DraftsIcon from '@mui/icons-material/Drafts';
import EditIcon from '@mui/icons-material/Edit';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FolderIcon from '@mui/icons-material/Folder';
import HandShakeIcon from '@mui/icons-material/Handshake';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import HighlightIcon from '@mui/icons-material/Highlight';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import InventoryIcon from '@mui/icons-material/Inventory';
import LanguageIcon from '@mui/icons-material/Language';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PaidIcon from '@mui/icons-material/Paid';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import PrintIcon from '@mui/icons-material/Print';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import RuleIcon from '@mui/icons-material/Rule';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import TuneIcon from '@mui/icons-material/Tune';
import VerifiedIcon from '@mui/icons-material/Verified';

import type { IconEnum } from '@e-socna/data-layer';

const ICON_COMPONENT_MAP = {
  Approval: ApprovalIcon,
  AssignmentInd: AssignmentIndIcon,
  Backspace: BackspaceIcon,
  BioTech: BioTechIcon,
  BrowserNotSupported: BrowserNotSupportedIcon,
  Business: BusinessIcon,
  BusinessCenter: BusinessCenterIcon,
  CancelSchedule: CancelScheduleIcon,
  Checklist: ChecklistIcon,
  CloudUpload: CloudUploadIcon,
  CorporateFare: CorporateFareIcon,
  DeleteForever: DeleteForeverIcon,
  DoneOutlined: DoneOutlinedIcon,
  Drafts: DraftsIcon,
  Edit: EditIcon,
  EmojiTransportation: EmojiTransportationIcon,
  Engineering: EngineeringIcon,
  ExitToApp: ExitToAppIcon,
  Folder: FolderIcon,
  HandShake: HandShakeIcon,
  HeartBroken: HeartBrokenIcon,
  Highlight: HighlightIcon,
  HighlightOff: HighlightOffIcon,
  HourglassEmpty: HourglassEmptyIcon,
  Inventory: InventoryIcon,
  Language: LanguageIcon,
  LocalPhone: LocalPhoneIcon,
  LocalShipping: LocalShippingIcon,
  LocationOn: LocationOnIcon,
  MarkEmailRead: MarkEmailReadIcon,
  NewReleases: NewReleasesIcon,
  NightShelter: NightShelterIcon,
  Notifications: NotificationsIcon,
  Paid: PaidIcon,
  PlayCircle: PlayCircleIcon,
  PrecisionManufacturing: PrecisionManufacturingIcon,
  Print: PrintIcon,
  QuestionMark: QuestionMarkIcon,
  ReceiptLong: ReceiptLongIcon,
  RequestQuote: RequestQuoteIcon,
  Rule: RuleIcon,
  ScheduleSend: ScheduleSendIcon,
  SentimentSatisfiedAlt: SentimentSatisfiedAltIcon,
  ThumbDown: ThumbDownIcon,
  ToggleOff: ToggleOffIcon,
  ToggleOn: ToggleOnIcon,
  Tune: TuneIcon,
  Verified: VerifiedIcon,
} as const;

export const getIconComponent = (icon: IconEnum) => ICON_COMPONENT_MAP[icon];

export const iconToMuiIcon = (icon: IconEnum) =>
  createElement(ICON_COMPONENT_MAP[icon]);
